import { useState, useEffect } from "react";

export const useFetchBlog = (slug) => {
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(true);

  const extractText = (obj) => {
    if (typeof obj === "string") return obj + " ";
    if (Array.isArray(obj)) return obj.map(extractText).join(" ");
    if (typeof obj === "object" && obj !== null) return Object.values(obj).map(extractText).join(" ");
    return "";
  };

  const calculateReadingTime = (text) => {
    const words = text.trim().split(/\s+/).length;
    return Math.ceil(words / 200);
  };

  useEffect(() => {
    if (!slug) return;

    const fetchData = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_CMS_BASE_URL}/api/blog-templates?filters[slug][$eq]=${slug}&populate[body_content][populate]=*&populate[banner_section][populate]=*`
          ,{
            method: 'GET', // or 'POST', 'PUT', etc.
            headers: {
              'Authorization': process.env.REACT_APP_CMS_KEY,
              'Content-Type': 'application/json' // if sending or receiving JSON
            }
          });
        const json = await res.json();
        const post = json?.data?.[0];

        if (!post) return;

        const bannerImage = post.banner_section?.find(sec => sec.__component === "banner.banner-image")?.banner_image?.url;
        const bannerTitle = post.banner_section?.find(sec => sec.__component === "banner.banner-title");
        const blogDescription = bannerTitle?.blog_description || "";

        const bodyText = post.body_content?.map(extractText).join(" ") || "";
        const readingTime = calculateReadingTime(bodyText);

        setBlogData({
          id: post.id,
          title: post.blog_titile || "No Title",
          description: blogDescription,
          imageUrl: bannerImage ? `${process.env.REACT_APP_CMS_BASE_URL}${bannerImage}` : null,
          published_date: post.publishedAt,
          slug: post.slug,
          category: post.category,
          readingTime,
          body_content: post.body_content || [],
          article_number: post.article_number,
        });
      } catch (err) {
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  return { blogData, loading };
};
